
    import Component from "vue-class-component";
    import {Prop} from "vue-property-decorator";
    import {
        ApplicationActions,
        EditDocumentSeedRequest,
        EditHarbourPilotExemptionCertificateSeedRequest,
        ResultError,
        HarboursClient,
        HarbourPilotExemptionCertificateDocumentApiModel,
        HarbourOption
    } from "@/api-client";
    import IssueDocumentInnerComponent from "@/features/applications/components/issue-document/IssueDocumentInnerComponent";
    import IssueDocumentSignature from "@/features/applications/components/issue-document/IssueDocumentSignature.vue";
    import DatePicker from "@/components/DatePicker.vue";
    import LabelOptional from "@/features/shared/components/LabelOptional.vue";
    import AdditionalInfoButton from "@/features/shared/components/AdditionalInfoButton.vue";

    @Component({
        components: {
            AdditionalInfoButton,
            DatePicker,
            IssueDocumentSignature,
            LabelOptional
        }
    })
    export default class IssueHarbourPilotExemptionCertificate extends IssueDocumentInnerComponent {
        @Prop({required: true})
        issueDocumentDetails!: HarbourPilotExemptionCertificateDocumentApiModel;
        @Prop({required: true})
        actions!: ApplicationActions;
        @Prop({required: true})
        errors!: ResultError;

        initialEditModel!: EditDocumentSeedRequest;
        harboursClient = new HarboursClient();

        validUntil = this.issueDocumentDetails.validUntil;
        issueDate = this.issueDocumentDetails.issueDate;
        additionalInfo = this.issueDocumentDetails.additionalInfo;
        harbourId: string | null = this.issueDocumentDetails.harbourId || null;
        harbourOptions: HarbourOption[] = [];

        async mounted() {
            await this.loadHarbours();
            this.initialEditModel = this.getEditModel();
        }

        async loadHarbours() {
            const response = await this.harboursClient.harbourOptions();
            this.harbourOptions = response.harbourOptions;
        }

        getEditModel(): EditDocumentSeedRequest {
            const request = new EditHarbourPilotExemptionCertificateSeedRequest();
            request.additionalInfo = this.additionalInfo;
            request.issueDate = this.issueDate;
            request.validUntil = this.validUntil;
            request.harbourId = this.harbourId;
            return request;
        }
    }
